/* ============================================
   MARIE BOTANIQUE — Theme JavaScript
============================================ */

document.addEventListener('DOMContentLoaded', () => {

  // ---- HEADER SCROLL ----
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('is-scrolled', window.scrollY > 40);
    }, { passive: true });
  }

// ---- MOBILE MENU ----
const mobileToggle = document.getElementById('mobile-menu-toggle');
const mobileMenu = document.getElementById('mobile-menu');
const mobileClose = document.getElementById('mobile-menu-close');
const mobileOverlay = document.getElementById('mobile-overlay');

function openMobileMenu() {
  mobileMenu.classList.add('is-open');
  mobileOverlay.classList.add('is-open');
  mobileMenu.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}
function closeMobileMenu() {
  mobileMenu.classList.remove('is-open');
  mobileOverlay.classList.remove('is-open');
  mobileMenu.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

mobileToggle?.addEventListener('click', openMobileMenu);
mobileClose?.addEventListener('click', closeMobileMenu);
mobileOverlay?.addEventListener('click', closeMobileMenu);

  // ---- SEARCH BAR ----
  const searchToggle = document.getElementById('search-toggle');
  const searchBar = document.getElementById('search-bar');
  const searchClose = document.getElementById('search-close');
  if (searchToggle && searchBar) {
    searchToggle.addEventListener('click', () => {
      searchBar.classList.add('is-open');
      searchBar.setAttribute('aria-hidden', 'false');
      setTimeout(() => searchBar.querySelector('input')?.focus(), 100);
    });
    searchClose?.addEventListener('click', closeSearch);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeSearch();
    });
    function closeSearch() {
      searchBar.classList.remove('is-open');
      searchBar.setAttribute('aria-hidden', 'true');
    }
  }

  // ---- CART DRAWER ----
  const cartDrawer = document.getElementById('cart-drawer');
  const cartToggle = document.getElementById('cart-toggle');
  const cartClose = cartDrawer?.querySelector('.cart-drawer__close');
  const cartOverlay = cartDrawer?.querySelector('.cart-drawer__overlay');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  cartToggle?.addEventListener('click', openCart);
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
      updateCartCount(cart.item_count);
    } catch (e) {
      console.error('Cart error:', e);
    }
  }

  function renderCart(cart) {
    const itemsEl = document.getElementById('cart-items');
    const totalEl = document.getElementById('cart-total');
    if (!itemsEl) return;

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '<p style="text-align:center;padding:40px;color:var(--text-subtle);font-style:italic;">Votre sélection est vide.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(item => `
        <div class="cart-item" style="display:flex;gap:16px;padding:16px 0;border-bottom:1px solid var(--border-light)">
          <a href="${item.url}">
            <img src="${item.image}" alt="${item.product_title}" style="width:72px;height:96px;object-fit:cover;flex-shrink:0" loading="lazy">
          </a>
          <div style="flex:1;min-width:0">
            <a href="${item.url}" style="font-size:14px;color:var(--charcoal);display:block;margin-bottom:4px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis">${item.product_title}</a>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p style="font-size:12px;color:var(--text-subtle);margin-bottom:8px">${item.variant_title}</p>` : ''}
            <div style="display:flex;align-items:center;justify-content:space-between;gap:8px">
              <div style="display:flex;align-items:center;border:1px solid var(--border);height:32px">
                <button onclick="updateItem(${item.key}, ${item.quantity - 1})" style="width:32px;height:100%;font-size:14px;cursor:pointer" aria-label="Diminuer">−</button>
                <span style="width:32px;text-align:center;font-size:13px">${item.quantity}</span>
                <button onclick="updateItem(${item.key}, ${item.quantity + 1})" style="width:32px;height:100%;font-size:14px;cursor:pointer" aria-label="Augmenter">+</button>
              </div>
              <span style="font-size:14px;font-weight:400">${formatMoney(item.final_line_price)}</span>
            </div>
          </div>
        </div>
      `).join('');
    }

    if (totalEl) {
      totalEl.textContent = formatMoney(cart.total_price);
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' $';
  }

  function updateCartCount(count) {
    const countEl = document.getElementById('cart-count');
    if (!countEl) return;
    if (count > 0) {
      countEl.textContent = count;
      countEl.style.display = 'flex';
    } else {
      countEl.style.display = 'none';
    }
  }

  window.updateItem = async function(key, qty) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      const cart = await res.json();
      renderCart(cart);
      updateCartCount(cart.item_count);
    } catch(e) {
      console.error(e);
    }
  };

  // ---- ADD TO CART ----
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('.product-card__add-btn, #add-to-cart');
    if (!btn || btn.disabled) return;
    e.preventDefault();

    let variantId;
    if (btn.id === 'add-to-cart') {
      variantId = document.getElementById('variant-id')?.value;
    } else {
      variantId = btn.dataset.productId;
    }
    if (!variantId) return;

    const qtyInput = document.querySelector('.qty-input');
    const quantity = qtyInput ? parseInt(qtyInput.value) : 1;

    btn.classList.add('loading');
    const orig = btn.innerHTML;
    btn.innerHTML = '✓';
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity })
      });
      if (!res.ok) throw new Error();
      await refreshCart();
      openCart();
    } catch {
      btn.innerHTML = 'Erreur';
    } finally {
      setTimeout(() => {
        btn.innerHTML = orig;
        btn.disabled = false;
        btn.classList.remove('loading');
      }, 1200);
    }
  });

  // ---- PRODUCT PAGE GALLERY ----
  const gallery = document.getElementById('product-gallery');
  if (gallery) {
    const slides = gallery.querySelectorAll('.product-gallery__slide');
    const thumbs = gallery.querySelectorAll('.product-gallery__thumb');
    const prev = gallery.querySelector('.gallery-arrow--prev');
    const next = gallery.querySelector('.gallery-arrow--next');
    let current = 0;

    function goTo(index) {
      slides[current]?.classList.remove('is-active');
      thumbs[current]?.classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current]?.classList.add('is-active');
      thumbs[current]?.classList.add('is-active');
    }

    prev?.addEventListener('click', () => goTo(current - 1));
    next?.addEventListener('click', () => goTo(current + 1));
    thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => goTo(i)));

    // Keyboard navigation
    gallery.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') goTo(current - 1);
      if (e.key === 'ArrowRight') goTo(current + 1);
    });

    // Touch swipe
    let startX = 0;
    gallery.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
    gallery.addEventListener('touchend', e => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) goTo(diff > 0 ? current + 1 : current - 1);
    });
  }

  // ---- PRODUCT VARIANTS ----
  const variantBtns = document.querySelectorAll('.product-option__btn');
  if (variantBtns.length > 0) {
    variantBtns.forEach(btn => {
      btn.addEventListener('click', async () => {
        const group = btn.closest('.product-option__values');
        group.querySelectorAll('.product-option__btn').forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');
        updateVariant();
      });
    });

    async function updateVariant() {
      const selected = {};
      document.querySelectorAll('.product-option').forEach(option => {
        const optionIndex = parseInt(option.querySelector('[data-option-index]')?.dataset.optionIndex);
        const val = option.querySelector('.product-option__btn.is-selected')?.dataset.value;
        if (optionIndex && val) selected[optionIndex] = val;
      });

      const productHandle = window.location.pathname.split('/').pop();
      try {
        const res = await fetch(`/products/${productHandle}.js`);
        const product = await res.json();
        const match = product.variants.find(v =>
          Object.keys(selected).every(i =>
            v[`option${i}`] === selected[i]
          )
        );
        if (match) {
          document.getElementById('variant-id').value = match.id;
          const priceEl = document.getElementById('product-price');
          if (priceEl) {
            priceEl.textContent = formatMoney(match.price * 100);
          }
          const addBtn = document.getElementById('add-to-cart');
          if (addBtn) {
            addBtn.disabled = !match.available;
            addBtn.textContent = match.available ? 'Ajouter à la sélection' : 'Épuisé';
          }
        }
      } catch(e) {
        console.error(e);
      }
    }
  }

  // ---- QUANTITY SELECTOR ----
  const qtyMinus = document.querySelector('.qty-minus');
  const qtyPlus = document.querySelector('.qty-plus');
  const qtyInput = document.querySelector('.qty-input');

  qtyMinus?.addEventListener('click', () => {
    if (qtyInput && parseInt(qtyInput.value) > 1) {
      qtyInput.value = parseInt(qtyInput.value) - 1;
    }
  });
  qtyPlus?.addEventListener('click', () => {
    if (qtyInput) qtyInput.value = parseInt(qtyInput.value) + 1;
  });

  // ---- TESTIMONIALS CAROUSEL ----
  const track = document.getElementById('testimonials-track');
  if (track) {
    const items = track.querySelectorAll('.testimonial');
    const dotsContainer = document.getElementById('testimonials-dots');
    const prev = document.querySelector('.testimonials__prev');
    const next = document.querySelector('.testimonials__next');
    let current = 0;

    // Build dots
    if (dotsContainer) {
      items.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = 'testimonials__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', `Avis ${i + 1}`);
        dot.addEventListener('click', () => goTo(i));
        dotsContainer.appendChild(dot);
      });
    }

    // On mobile, hide all but current
    function isMobile() { return window.innerWidth < 900; }

    function goTo(i) {
      if (!isMobile()) return;
      items[current].style.display = 'none';
      document.querySelectorAll('.testimonials__dot')[current]?.classList.remove('is-active');
      current = (i + items.length) % items.length;
      items[current].style.display = 'block';
      document.querySelectorAll('.testimonials__dot')[current]?.classList.add('is-active');
    }

    function initCarousel() {
      if (isMobile()) {
        items.forEach((item, i) => {
          item.style.display = i === current ? 'block' : 'none';
        });
        prev?.style.setProperty('display', 'flex');
        next?.style.setProperty('display', 'flex');
      } else {
        items.forEach(item => item.style.display = '');
      }
    }

    prev?.addEventListener('click', () => goTo(current - 1));
    next?.addEventListener('click', () => goTo(current + 1));

    initCarousel();
    window.addEventListener('resize', initCarousel, { passive: true });
  }

  // ---- REVEAL ON SCROLL ----
  const revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const delay = entry.target.dataset.delay || 0;
          setTimeout(() => {
            entry.target.classList.add('is-visible');
          }, parseInt(delay));
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

    revealEls.forEach(el => observer.observe(el));
  }

  // ---- INIT CART COUNT ----
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => updateCartCount(cart.item_count))
    .catch(() => {});

});
